<template>
  <InlineSearchField
    :autofocus="!$store.getters.use_keyboard"
    :label="$t('Поиск гостя')"
    :messages="[$t('Введите номер телефона или ФИО гостя')]"
    
    @focus.stop="e => $store.dispatch('inputFocus', e)"
    kbd-layout="numpad"
    @runQuery="doSearch"
    @click:item="e => $emit('input', e)"
    :items="search_results"  
    v-model="search_value"
  >
    <template #items="{ items, debounce }">
      <v-list dense>
        <v-progress-linear color="primary" indeterminate v-if="debounce"></v-progress-linear>
        <ScrollerHandler style="max-height: calc(40vh - 20px)">
            <v-list-item test-tag="tag-103" :disabled="debounce" v-for="item in items" :key="item.id" @click="$emit('input', item)">
              <v-list-item-avatar><v-icon>mdi-account-outline</v-icon></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{item.name}}</v-list-item-title>
                <v-list-item-subtitle v-if="item.phones.length > 0">
                  <PhoneFormatter :value="item.phones.filter(el => el.id == item.default_phone)[0]?.number" />
                </v-list-item-subtitle>
                <v-list-item-subtitle v-else>
                  &lt;<T>Телефон не указан</T>&gt;
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.email">{{ item.email }}</v-list-item-subtitle>
                <v-list-item-subtitle v-else>&lt;<T>Email не указан</T>&gt;</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
            </v-list-item>
            
            <v-list-item test-tag="tag-104" v-if="items != undefined" :disabled="debounce" :key="0" @click="$emit('input', defaultGuest)">
              <v-list-item-avatar><v-icon color="primary">mdi-account-plus-outline</v-icon></v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title style="font-size: 1.2em"><T>Новый гость</T></v-list-item-title>
              </v-list-item-content>
              <v-list-item-action><v-icon color="primary">mdi-chevron-right</v-icon></v-list-item-action>
            </v-list-item>
            <v-alert
              v-else
              outlined
              border="left"
              type="warning"
              :key="-1"
            >
              <T>Введите номер телефона или ФИО гостя</T><br><br>
              (<T>не менее трех символов</T>)
            </v-alert>
        </ScrollerHandler>
      </v-list>
    </template>
  </InlineSearchField>
</template>

<script>
import ScrollerHandler from '@/components/scroller_handler'
import InlineSearchField from '@/components/common/InlineSearchField'
import PhoneFormatter from '@/components/common/PhoneFormatter'

export default {
  data: () => ({
    search_results: undefined,
    search_value: undefined,
    need_push_phone: true
  }),
  methods: {
    async doSearch(cond) {
      
      if (([null, undefined, ''].includes(cond)) || (cond.length < 3)) {
        this.search_results = []
        this.$nextTick(() => this.search_results = undefined)
        
        return;
      }

      this.search_results = await this.$store.dispatch('apiQuery', {method: `/guest${this.searchRoute}`, body:{ query: cond }})
      
    }
  },
  computed: {
    searchMode() {
      return /[0-9]/g.test(this.search_value?.replaceAll('+', '')) ? 'phone' : 'name'
    },
    searchRoute() {
      return this.searchMode === 'phone' ? '/search/phone' : '/search'
    },
    defaultGuest() {
      return {
        ...{
          addresses: [],
          phones: [],
          default_address: null,
          default_phone: null,
          anonymous: false,
          name: "",
          email: "",
          extra: "",
          black_list: false
        },
        ...this.searchMode === 'phone' ? this.need_push_phone ? {push_phone: {number: this.search_value}} : {} : {},
        ...this.searchMode === 'name' ? {name: this.search_value} : {},
      }
    }
  },
  components: {
    InlineSearchField,
    ScrollerHandler,
    PhoneFormatter
  }
}
</script>